export default {"src":"/_next/static/media/btx.db765c1a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};